
import { storage } from '../lib/storage';
import { WishlistItem, Product } from '../types';

export const wishlistService = {
  getWishlist: (userId: string): WishlistItem[] => {
    const data = localStorage.getItem('lynqar_wishlist');
    const all: WishlistItem[] = data ? JSON.parse(data) : [];
    return all.filter(item => item.userId === userId);
  },

  toggleWishlist: (userId: string, product: Product) => {
    const data = localStorage.getItem('lynqar_wishlist');
    let all: WishlistItem[] = data ? JSON.parse(data) : [];
    
    const existingIdx = all.findIndex(item => item.userId === userId && item.productId === product.id);
    
    if (existingIdx !== -1) {
      all.splice(existingIdx, 1);
    } else {
      all.push({
        id: 'wish-' + Date.now(),
        userId,
        productId: product.id,
        storeId: product.storeId,
        addedAt: new Date().toISOString()
      });
    }
    
    localStorage.setItem('lynqar_wishlist', JSON.stringify(all));
    window.dispatchEvent(new Event('wishlist-update'));
    
    // Update product stats
    const products = storage.getProducts();
    const target = products.find(p => p.id === product.id);
    if (target) {
      target.wishlistCount = all.filter(item => item.productId === product.id).length;
      storage.saveProducts(products);
    }
  },

  isInWishlist: (userId: string, productId: string): boolean => {
    const data = localStorage.getItem('lynqar_wishlist');
    const all: WishlistItem[] = data ? JSON.parse(data) : [];
    return all.some(item => item.userId === userId && item.productId === productId);
  },

  getStoreWishlistStats: (storeId: string) => {
    const data = localStorage.getItem('lynqar_wishlist');
    const all: WishlistItem[] = data ? JSON.parse(data) : [];
    const storeWishlist = all.filter(item => item.storeId === storeId);
    
    const products = storage.getProducts().filter(p => p.storeId === storeId);
    
    return products.map(p => ({
      ...p,
      wishlistCount: storeWishlist.filter(item => item.productId === p.id).length
    })).sort((a, b) => (b.wishlistCount || 0) - (a.wishlistCount || 0));
  }
};
